import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import HtmlHeader from "@template/components/HtmlHeader";
import Breadcrumbs from "@template/components/Breadcrumbs";
import Footer from "@template/components/Footer";
import WelcomeMessage from "@template/components/WelcomeMessage";
import InfoBanner from "@template/components/InfoBanner/InfoBannerControl";
import { isMainAppHidden } from "@template/state/modules/layout/selectors";
import SidePanel from "@template/components/Navigation/SidePanel";
import SecuredTouch from "@template/components/Footer/SecuredTouch";
import SecureScriptContainer from "@template/components/Footer/SecureScriptContainer";

const MainContentComponent = ({ isMainAppHidden, webContext }) => (
  <div
    aria-hidden={isMainAppHidden}
    className="chrome-main-content--accessible"
  >
    <div id="chrome-header">
      <HtmlHeader />
    </div>
    <div id="chrome-breadcrumb">
      <Breadcrumbs />
    </div>
    <main
      id="chrome-app-container"
      dangerouslySetInnerHTML={{ __html: "<!--%applicationContent%-->" }}
    ></main>
    <div id="chrome-footer">
      <Footer />
      <SecuredTouch />
      <SecureScriptContainer webContext={webContext} />
    </div>
    <div id="chrome-welcome-mat">
      <WelcomeMessage />
    </div>
    <div id="chrome-info-banner">
      <InfoBanner />
    </div>
  </div>
);

const ModalContentComponent = ({ isMainAppHidden }) => (
  <div
    id="chrome-modal-container"
    aria-hidden={!isMainAppHidden}
    aria-modal="true"
    role="dialog"
  >
    <SidePanel />
  </div>
);

ModalContentComponent.propTypes = {
  isMainAppHidden: PropTypes.bool
};

MainContentComponent.propTypes = {
  isMainAppHidden: PropTypes.bool,
  webContext: PropTypes.object
};

const mapStateToProps = state => ({
  isMainAppHidden: isMainAppHidden(state)
});
export const ModalContent = connect(mapStateToProps)(ModalContentComponent);
export const MainContent = connect(mapStateToProps)(MainContentComponent);
